import { UtilityProgramViewConfig } from '@/types/utilityProgram'

const RATE_LABELS = [
  'Ultra Off-Peak',
  'Mega Off-Peak',
  'Super Off-Peak',
  'Off-Peak',
  'Standard',
  'On-Peak',
  'Super On-Peak',
  'Mega On-Peak',
  'Ultra On-Peak',
]

export default function centeredRateIndexToLabel(
  centeredIdx?: number,
  viewConfig?: UtilityProgramViewConfig,
): string {
  let rateLabels = RATE_LABELS
  const viewConfigCsl = viewConfig?.homeEnergyPreview?.touCsl
  if (viewConfigCsl?.length ?? (0 > 0 && viewConfigCsl)) {
    rateLabels = viewConfigCsl.split(',')
  }
  if (centeredIdx === undefined || centeredIdx === null) {
    return 'Flat-Rate'
  }
  const idx = centeredIdx + Math.floor(rateLabels.length / 2)
  return rateLabels[idx]
}
